import * as React from "react"

const Lock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      d="M8.06 1.5H8a3.59 3.59 0 0 0-3.5 3.61V6H2v8h12V6h-2.44v-.89a3.59 3.59 0 0 0-3.5-3.6V1.5Zm2.5 4.5v-.89c0-1.44-1.13-2.6-2.53-2.6A2.59 2.59 0 0 0 5.5 5.1V6h5.06ZM3 7h10v6H3V7Z"
    />
  </svg>
)

export default Lock
